import {
  Button,
  Divider,
  Form,
  Input,
  message,
  Popconfirm,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import { addNewArticle } from "../action";
import { ICategory } from "../../../types/Category";
import { getCategories } from "../../Categories/action";
import { PiPlus } from "react-icons/pi";

type Props = {
  onArticleAdded?: () => void;
};

interface FormData {
  title: string;
  category: string;
  author?: string;
  source_name?: string;
  source_link?: string;
}
const AddNewArticle = (props: Props) => {
  const { onArticleAdded } = props;
  const [form] = Form.useForm<FormData>();
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [loading, setIsLoading] = useState<boolean>(false);

  const fetchCategories = async () => {
    const result = await getCategories();
    if (result) {
      setCategories(result);
    }
  };
  const onSubmit = async (values: FormData) => {
    setIsLoading(true);
    try {
      const result = await addNewArticle(
        values.title,
        values.category,
        values.author,
        values.source_name,
        values.source_link
      );
      if (result) {
        message.success("Article added successfully");
        form.resetFields();
        onArticleAdded?.();
      }
    } catch (err) {
      message.error("Failed to add article, please try again");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);
  return (
    <Form layout="vertical" form={form} onFinish={onSubmit}>
      <Form.Item
        name="title"
        label="Title"
        rules={[{ required: true, message: "Please enter article title" }]}
      >
        <Input placeholder="Enter article title" />
      </Form.Item>
      <Form.Item
        name="category"
        label="Category"
        rules={[{ required: true, message: "Please select category" }]}
      >
        <Select
          placeholder="Select category"
          options={categories.map((item) => ({
            label: item.MainInfo.Title,
            value: item.id,
          }))}
        />
      </Form.Item>
      <Divider />
      <Form.Item name="author" label="Author">
        <Input placeholder="Enter author" />
      </Form.Item>
      <div className="grid grid-cols-2 gap-4">
        <Form.Item name="source_name" label="Source Name">
          <Input placeholder="Enter source name" />
        </Form.Item>
        <Form.Item name="source_link" label="Source Link">
          <Input placeholder="Enter source link" />
        </Form.Item>
      </div>
      <Popconfirm
        title="Add Article"
        description="Are you sure you want to add this article?"
        onConfirm={() => form.submit()}
        okText="Yes"
        cancelText="No"
      >
        <Button type="primary" icon={<PiPlus />} loading={loading}>
          Add New Article
        </Button>
      </Popconfirm>
    </Form>
  );
};

export default AddNewArticle;
